import {DropdownWithButton, DropdownListItem, ButtonComponentProps, Button} from '@hm/fundamental'
import {mdiDotsVertical, mdiPencilOutline} from '@mdi/js'
import {forwardRef} from 'react'
import {useTranslation} from 'react-i18next'

import {useRefraModal} from '@refra/modules/common/providers'
import {EditStaticPartModal} from '@refra/modules/refra-static-parts/components/StaticPartsOverview/StaticPartModal'
import {StaticPartDTO} from '@refra/modules/refra-static-parts/types'

interface StaticPartsOverviewDropdownProps {
  staticPart: StaticPartDTO
}

export const StaticPartsOverviewDropdown: React.FC<StaticPartsOverviewDropdownProps> = ({
  staticPart
}) => {
  const {t} = useTranslation()

  const {openModal} = useRefraModal()

  const customButton = forwardRef<HTMLButtonElement, ButtonComponentProps>(
    ({label, isDropdownOpen, onClick}, ref) => {
      return (
        <Button
          icon={mdiDotsVertical}
          ref={ref}
          square
          variant={'tertiary'}
          toggled={isDropdownOpen}
          onClick={(e) => {
            if (onClick) {
              e.stopPropagation()
              onClick(e)
            }
          }}
          data-cy="static_parts_overview_dropdown_button"
        >
          {label}
        </Button>
      )
    }
  )

  return (
    <DropdownWithButton
      variant="secondary"
      dropdownWidth={200}
      component={customButton}
      data-cy="static_parts_overview_dropdown"
    >
      <DropdownListItem
        titleClassName={'text-primary'}
        icon={mdiPencilOutline}
        title={t('common.edit')}
        onClick={() => openModal(<EditStaticPartModal staticPart={staticPart} />)}
        data-cy="static_parts_overview_dropdown_edit_item"
      />
    </DropdownWithButton>
  )
}
